import { Box } from '@mui/material';
import { useContext } from 'react';
import { ConfigContext } from '../App/App';
import FormsHomeList from '../ConversationalForms/FormsHomeList';
import Header from '../Shared/Header/Header';
import WrapperBox from '../Shared/WrapperBox/WrapperBox';
import SplashActions from './SplashActions/SplashActions';
import SplashHeader from './SplashHeader/SplashHeader';
function Splash() {
  const config = useContext(ConfigContext);
  return (
    <WrapperBox>
      <Header pageName='' />
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: config.Gap, flexDirection: 'column', }}>
        <SplashHeader />
        <SplashActions />
        {/* Multiform tenants only: the same forms-menu rows, standing; actions
            navigate to chat. Renders nothing otherwise. */}
        <FormsHomeList />
      </Box>
    </WrapperBox>
  );
}
export default Splash;
